import { sensor } from "@/store";

export default function () {
    const turnOn = (id: string) => sensor.SetDeviceStatus({ id, status: true });
    const turnOff = (id: string) => sensor.SetDeviceStatus({ id, status: false });

    const isBusy = (id: string) => {
        const dev = sensor.devices.find(d => d.attachedDeviceId === id) as any;
        return dev?.isBusy === true || dev?.isConnecting === true;
    };

    const isOn = (id: string) => {
        const dev = sensor.devices.find(d => d.attachedDeviceId === id) as any;
        return dev?.status === true;
    };

    return { turnOn, turnOff, isBusy, isOn };
}